module.exports = __webpack_public_path__ + "b28bb213a33ec497259f8ed71d659b29.png";